<template>
    <div style="direction:rtl">
        <CCard>
            <CCardHeader>
                <div style="display:flex;flex-direction:row;gap:10px;">
                        <h3 class="card-title"  > <CIcon name="cil-map" style="width: 20px;height: 20px"/>&nbsp;&nbsp;
                        کنترل خطوط
                    </h3>
                    <div style="flex-grow:1;">

                    </div>
                    <CSelect label="مرتب سازی سازی بر اساس:"    :options="SortList" :value.sync="sortOrder" @change="SortChange" > </CSelect>
                </div>
            </CCardHeader>
            <CCardBody>
                <template v-for="(item,index) in BusLines" >
                    <CAlert :color="getColor(item)" v-bind:key="index" v-if="(FleetSelect===-1 || FleetSelect===item.FleetID)">
                        <table style="width:100%">
                                <tr>
                                    <td><strong>نام خط:</strong></td>
                                    <td v-text="item.LineName"></td>
                                    <td><strong>طول مسیر رفت(متر):</strong></td>
                                    <td v-text="item.LengthWentPath"></td>
                                    <td><strong>طول مسیر برگشت(متر):</strong></td>
                                    <td v-text="item.LengthBackPath"></td>
                                </tr>
                                <tr>
                                    <td><strong>تعداد کل اتوبوس:</strong></td>
                                    <td v-text="item.TotalDevice"></td>
                                    <td><strong>تعداد اتوبوس در مسیر رفت:</strong></td>
                                    <td v-text="item.WentDirection"></td>
                                    <td><strong>تعداد اتوبوس در مسیر برگشت:</strong></td>
                                    <td v-text="item.BackDirection"></td>
                                </tr>
                                <tr>
                                    <!-- <td><strong>تعداد کل اتوبوس:</strong></td>
                                    <td v-text="item.TotalDevice"></td>
                                    <td><strong>تعداد اتوبوس در مسیر رفت:</strong></td>
                                    <td v-text="item.WentDirection"></td> -->
                                    <td colspan="2"><strong>
                                        </strong></td>
                                    <td colspan="2"><strong></strong></td>
                                    <td colspan="2" style="direction:ltr"><strong>
                                        <CButton color="outline-warning" @click="ShowLineInformation(index,item)">مشاهده</CButton>
                                    </strong></td>
                                    
                                </tr>
                        </table>
                        <div>
                        </div>
                        <CCollapse :show="ShowLine===item.FleetID"  :duration="500">
                        <CCard style="width: 100%;height:200px ;">
                            <CCardBody>
                            <div style="display:flex;flex-direction:column;gap:20px" v-if="ShowLine===item.FleetID">
                                <strong >خط رفت</strong>
                                <div ref="Lin" id="mydiv" style="float:right;width:100%;background:#FF000096;height:30px;position: relative;direction:ltr">
                                    
                                    <template v-for="(station,index) in $store.state.LineStations_GetByUserID.RequestResponse">
                                         <img v-if="station.Direction===1" v-bind:key="index+1000" :title="station.StationName" width="40px" height="40px" src="/images/station.png" :style="'cursor: pointer;position: absolute;bottom:25px;left:'+GetPositionStation(station,item,true)+'px'"  >
                                    </template>
                                    <template v-for="(device,index) in Devices">
                                        <img  v-if="device.Direction===1" v-bind:key="index+2000" src="/images/bus.png" :style="'position: absolute;width:40px;height:30px;-webkit-transform: scaleX(-1);transform: scaleX(-1);left:'+GetPositionDevice(device,item,true)+'px'" >
                                    </template>
                                </div>
                                <strong >خط برگشت</strong>
                                 <div style="float:right;width:100%;background:#0000FF96;height:30px;position: relative;direction:ltr">
                                     <template v-for="(station,index) in $store.state.LineStations_GetByUserID.RequestResponse">
                                         <img v-if="station.Direction===2" v-bind:key="index+3000" :title="station.StationName" width="40px" height="40px" src="/images/station.png" :style="'cursor: pointer;position: absolute;bottom:25px;right:'+GetPositionStation(station,item,false)+'px'" >
                                    </template>
                                    <template v-for="(device,index) in Devices">
                                        <img  v-if="device.Direction===2" v-bind:key="index+4000" src="/images/bus.png" :style="'position: absolute;width:40px;height:30px;right:'+GetPositionDevice(device,item,false)+'px'" >
                                    </template>
                                </div>
                            </div>

                            </CCardBody>
                        </CCard>
                    </CCollapse>
                    </CAlert>
                </template>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
 import Vue from 'vue'
import { latLng } from "leaflet";
import Constant from './../../assets/Constants'
    export default {
        name: "Line_Control",
        data(){
            return {
                TimerActive:false,
                zoom: 13,
                center: latLng(35.708309, 51.380730),
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:
                    '&copy; <a href="#">RADA Smart City</a> contributors',
                    wmsLayer: {
                    url: 'https://gis.shiraz.ir/shirazgis/gis_workspace/wms?',
                    name: 'Weather Data',
                    visible: true,
                    format: 'image/png',
                    layers: 'regionwms',
                    transparent: true,
                    attribution: 'Weather data &copy; 2012 <a href="https://mesonet.agron.iastate.edu/docs/nexrad_mosaic/">IEM Nexrad</a>',
                },
                fields1:[{key:'DeviceID',label:'شناسه دستگاه'},{key:'FleetID',label:'شناسه خط'},{key:'OriginDistance',label:'فاصله تا ابتدای خط'},{key:'LastUpdateTime',label:'آخرین به روز رسانی'},{key:'CurrVehicleName',label:'نام اتوبوس'},{key:'CurrDriverName',label:'نام راننده'}],
                Lines:[],
                LineStations:[],
                WidthSize:0,
                User:null,
                SelectStation:{},
                SelectVehicle:{},
                SelectIndex:{},
                SelectLine:{},
                DialogShowStation:false,
                DialogShowVehicle:false,
                ShowMap:false,
                ShowHistory:false,
                ShowDevices:-1,
                FleetSelect:-1,
                Devices:[],
                ShowLine:-1,
                BusLines:[],
                SortList:[
                    {label:'بیشترین ظرفیت',value:"-Persent"},
                    {label:'کمترین ظرفیت',value:"Persent"},
                    {label:'بیشترین اتوبوس',value:"-TotalDevice"},
                    {label:'کمترین اتوبوس',value:"TotalDevice"},
                ],
                sortOrder:'-Persent'

            }
        },
        computed:{
            ReadLineStations(){
                return this.$store.state.LineStations;
            },
            ReadBusLine_GetByUserID(){
                return this.$store.state.BusLine_GetByUserID;
            },
            ReadDevices(){
                return this.$store.state.Trajectory_GetByUserID;
            }
        },
        watch:{
            ReadLineStations(data){
                console.log('ddddddddddddddddddddd')
                console.log(data)
                if(data.length>0){
                    var that=this;
                    setTimeout(function() {
                    that.WidthSize=document.getElementById("mydiv").offsetWidth;

                    }, 500);
                    
                }
            },
            ReadBusLine_GetByUserID(res){
                if(res.Status){
                    if(this.ShowLine!==-1){
                        this.BusLines=res.RequestResponse
                    }
                    else{
                        this.BusLines=this.Sorting(this.$store.state.BusLine_GetByUserID.RequestResponse,this.sortOrder)
                    }
                    
                }
            }, 
            ReadDevices(res){
                if(res.Status){
                    this.Devices=res.RequestResponse;
                }
            }
        },
        mounted(){
            this.TimerActive=true;
            this.Refresh();
            this.GetBusLine();
        },
        created() {
            window.addEventListener("resize", this.myEventHandler);
        },
        destroyed() {
            window.removeEventListener("resize", this.myEventHandler);
        },
        methods:{
            SortChange(){
                var res=this.$store.state.BusLine_GetByUserID;
                if(res.Status){
                    this.BusLines=this.Sorting(this.$store.state.BusLine_GetByUserID.RequestResponse,this.sortOrder)
                }
            },
            getColor(item){
                // var TotalDevice=item.TotalDevice;
                // var InLine=item.WentDirection+item.BackDirection;
                var persent=item.Persent;
                if(persent>80){
                    return "success"
                }
                else if(persent>50){
                    return "info"
                }
                else if(persent>20){
                    return "warning"
                }
                else{
                    return "danger"
                }

            },
            Sorting(items,order){
                return items.sort(this.dynamicSort(order));
            },
            dynamicSort(property) {
                var sortOrder = 1;
                if(property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a,b) {
                    /* next line works with strings and numbers, 
                    * and you may want to customize it to your needs
                    */
                    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            },
            ShowLineInformation(index,item){
                if(this.ShowLine!==item.FleetID){
                    this.FleetSelect=item.FleetID
                    this.ShowLine=item.FleetID;
                    this.GetLineStations_GetByUserID(item.FleetID);
                    this.GetTrajectory(item.FleetID);

                }
                else{
                    this.ShowLine=-1;
                    this.FleetSelect=-1;
                }
            },
            GetBusLine(){   
                this.$store.commit('BusLine_GetByUserID',{
                    UserID:2188
                    });
                
            },
            Refresh(){
                if(this.TimerActive){
                    var delayInMilliseconds = 15000; //15 second
                    var that=this;
                    setTimeout(function() {
                    if(this.ShowLine!==-1){
                        that.GetTrajectory(that.FleetSelect);
                    }
                    that.GetBusLine();
                        
                    that.Refresh();

                    }, delayInMilliseconds);
                }
                
            },
             GetLineStations_GetByUserID(fleetID){
                 this.$store.commit('LineStations_GetByUserID',{
                    UserID:2088,
                    FleetID:fleetID,
                    });
            },
            GetTrajectory(fleetID){
                this.$store.commit('Trajectory_GetByUserID',{
                    UserID:2088,
                    FleetID:fleetID,
                });
            },
             myEventHandler(e) {
                 this.WidthSize=document.getElementById("mydiv").offsetWidth;
                 console.log("WidthSize --> "+document.getElementById("mydiv").offsetWidth);
            },
            GetPositionWent(total,pos){
                console.log("position:")
                var position=( (this.WidthSize-80)/total)*pos;
                console.log("pos:"+pos+" total:"+total+" width:"+this.WidthSize)
                 console.log("position:")
                console.log(position)
                if(position<250){
                     return -250+position;
                }
                else if(position+250>this.WidthSize){
                    return -125+(this.WidthSize-position+100);
                }
                else {
                    return -125;
                }/*return -125;*/
                
            },     
            GetPositionBack(total,pos){
                console.log("position:")
                var position=( this.WidthSize/total)*pos;
                console.log("pos:"+pos+" total:"+total+" width:"+this.WidthSize)
                 console.log("position:")
                console.log(position)
                 if(position<250){
                     return -125;
                }
                else if(position+250>this.WidthSize){
                    return 0; 
                }
                else {
                    return -125;
                }
               
            },
            ShowVehicleInformation(vehicle,line,index){
                console.log(vehicle);
               
                this.SelectLine=line;
                this.SelectIndex=index;
                this.DialogShowVehicle=true;
                var distanseWent=0;
                var distanseBack=0;
                if(vehicle.Direction==='1'){
                    
                    if(index+1<line.Devices.Went.length){
                         console.log("step1 -1");
                        distanseWent=parseInt(line.Devices.Went[index+1].OriginDistance)-parseInt(vehicle.OriginDistance);    
                    }
                    else if(line.Devices.Back.length!==0){
                        console.log("step1 -2");
                        distanseWent=parseInt(line.info.LengthWentPath)-parseInt(vehicle.OriginDistance);  
                        distanseWent+=parseInt(line.Devices.Back[0].OriginDistance);  
                    }
                    else {
                        console.log("step1 - 3");
                        distanseWent=parseInt(line.info.LengthWentPath)-parseInt(vehicle.OriginDistance);
                        distanseWent+=parseInt(line.info.LengthBackPath);
                        distanseWent+=parseInt(line.Devices.Went[0].OriginDistance);
                    }
                }
                else {
                    if(index+1<line.Devices.Back.length){
                        console.log("step2 -1");
                        distanseWent=parseInt(line.Devices.Back[index+1].OriginDistance)-parseInt(vehicle.OriginDistance);    
                    }
                    else if(line.Devices.Went.length!==0){
                        console.log("step2 -2");
                        distanseWent=parseInt(line.info.LengthBackPath)-parseInt(vehicle.OriginDistance);  
                        distanseWent+=parseInt(line.Devices.Went[0].OriginDistance);  
                    }
                    else {
                        console.log("step2 - 3");
                        distanseWent=parseInt(line.info.LengthBackPath)-parseInt(vehicle.OriginDistance);
                        distanseWent+=parseInt(line.info.LengthWentPath);
                        distanseWent+=parseInt(line.Devices.Back[0].OriginDistance);//-parseInt(vehicle.OriginDistance);
                    }
                }/**/


                if(vehicle.Direction==='1'){
                    
                    if(index-1>=0){
                        distanseBack=parseInt(vehicle.OriginDistance)-parseInt(line.Devices.Went[index-1].OriginDistance);    
                    }
                    else if(line.Devices.Back.length!==0){
                        distanseBack=parseInt(vehicle.OriginDistance);  
                        distanseBack+=parseInt(line.Devices.Back[line.Devices.Back.length-1].OriginDistance)-parseInt(vehicle.OriginDistance);  
                    }
                    else {
                        distanseBack=parseInt(vehicle.OriginDistance);//-;
                        distanseBack+=parseInt(line.info.LengthBackPath);
                        distanseBack+=(parseInt(line.info.LengthWentPath)-parseInt(line.Devices.Went[line.Devices.Went.length-1].OriginDistance));
                    }
                }
                else {
                      
                    if(index-1>=0){
                        distanseBack=parseInt(vehicle.OriginDistance)-parseInt(line.Devices.Back[index-1].OriginDistance);    
                    }
                    else if(line.Devices.Went.length!==0){
                        distanseBack=parseInt(vehicle.OriginDistance);  
                        distanseBack+=parseInt(line.Devices.Went[line.Devices.Went.length-1].OriginDistance)-parseInt(vehicle.OriginDistance);  
                    }
                    else {
                         console.log("step4 - 3");
                        distanseBack=parseInt(vehicle.OriginDistance);//-;
                        distanseBack+=parseInt(line.info.LengthWentPath);
                        distanseBack+=(parseInt(line.info.LengthBackPath)-parseInt(line.Devices.Back[line.Devices.Back.length-1].OriginDistance));
                    }
                }/**/
                vehicle.distanseWent=distanseWent;
                vehicle.distanseBack=distanseBack;
             this.SelectVehicle=vehicle;
            },
            ShowStationInformation(station){
                this.SelectStation=station;
                this.DialogShowStation=true;
            },
            GetPositionStation(station,line,went){
                //var width=this.$refs.Lin.offsetWidth-20;
                var width=document.getElementById("mydiv").offsetWidth-40;
                if(went){
                    var position=(width*station.DistanceFromStart)/line.LengthWentPath
                    return position;
                }
                else{
                    var position=(width*station.DistanceFromStart)/line.LengthBackPath
                    return position;
                }
                
            },     
            GetPositionDevice(device,line,went){
                //var width=this.$refs.Lin.offsetWidth-20;
                var width=document.getElementById("mydiv").offsetWidth-40;
                // if(went){
                   
                // }
                // else{
                //     var position=(width*device.OriginDistance)/line.LengthBackPath
                //     return position;
                // }
                 var position=(width*device.OriginDistance)/device.PathLength
                    return position;
            }     
        },
        destroyed(){
            this.TimerActive=false;
      }
    }
</script>

<style scoped>

</style>